import { Component, OnInit } from '@angular/core';

@Component({
  template: `<router-outlet></router-outlet>`,
  styles: [``]
})
export class RootComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
